import React, { useEffect, useRef } from "react";
import { InputTextarea } from 'primereact/inputtextarea';
import "./UserInputTextarea.css";
import { TextareaAutosize } from "@mui/material";

const UserInputTextarea = ({ userInput, setUserInput, handleUserInput }) => {
    const inputRef = useRef(null);

    useEffect(() => {
        if (inputRef.current) {
            inputRef.current.style.height = 'auto';
            inputRef.current.style.height = `${Math.min(inputRef.current.scrollHeight, 100)}px`;
        }
    }, [userInput]);

    return (
        <TextareaAutosize
            minRows={3}
            ref={inputRef}
            id="userinput"
            placeholder="Type a message..."
            value={userInput}
            onChange={(e) => setUserInput(e.target.value)}
            onKeyDown={handleUserInput}
            className="p-mr-2"
            autoResize={false}
            rows={1}
            style={{
                width: "100%",
                padding: "8px",
                border: "none",
                outline: "none",
                resize: "none",
                backgroundColor: "transparent",
                fontSize: "16px",
                fontFamily: "inherit",
                overflow: 'auto'
            }}
        />

    );
};

export default UserInputTextarea;
